import { getDictionariesCom } from '@/utils/index.js'

export default {
  props: {},
  data() {
    return {
      userInfo: {},
      platformList: [], // 平台
      platformListFilter: [], // 有过滤平台
      dictionaries: { // 字典数据
        // customer_tag_status: [], // 标签状态（1-启用，2-暂停，3-回收站）
        commission_type: [], // 佣金类型
        commission_settlement_status: [], // 状态
        gift_package_pay_type: [], // 支付方式
        enable_status: [], // 状态
        commission_arrival_type: [], // 提现平台
        commission_apply_status: [], // 提现管理状态
        goods_tag_type: [],//标签分类
        goods_tag_class: [],//标签类目
        coupon_type: [],// 优惠券类型
        coupon_scope: [],// 优惠券适用范围
        coupon_user_scope: [],//优惠券适用用户
        web_template_enter_type: [],//页面类型
      }
    }
  },
  computed: {},
  filters: {},
  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    // this.getButtonTreeDto()
    this.initializationData() // 初始化数据
    // 获取字典值
    // getDictionariesCom(this.dictionaries).then(res => {
    //   // this.dictionaries.commission_type.splice(3,1)
    // })
  },
  methods: {
    // 初始化数据
    initializationData() {
      // const routeName = this.$route
      // this.getPlatformList()// 获取平台列表
      /*
      switch (routeName) {
        case 'dataBoardIndex':
          // 首页
          this.getVariation(true) // 销售总额XX天变化趋势
          break
        case 'dataBoardOrder':
          // 订单
          this.getVariation(true) // 销售总额XX天变化趋势
          break
        default: // 首页
          // console.log(matched[matched.length - 1].meta.title)
      }
      */
    },
    // 获取平台列表
    getPlatformList() {
      const params = {}
      this.$api.platformDataList(params).then((res) => {
        console.log(res)
        this.platformList = res.data
        const tempArr = []
        /*
        健驰健康服务小程序
        天兰茶叶（优购）小程序
        健驰优选小程序
        九航大健康
        宜关小程序
        天兰小程序
        健驰优选app
         */
        res.data.forEach(item => {
          if (item.name.indexOf('app') > -1 || item.name.indexOf('小程序') > -1 || item.name.indexOf('大健康') > -1 || item.name.indexOf('九航') > -1) {
            tempArr.push(item)
          }
        })
        this.platformListFilter = tempArr
      }).catch((err) => {
        console.log(err)
      })
    },
    // 防抖
    simpleDebounce(fn, delay = 100) {
      let timer = null
      return function () {
        const args = arguments
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    }
  }
}
